import {Component} from '@angular/core';
import {AngularFireAnalytics} from '@angular/fire/analytics';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ngx-storage-firebaseui-demo';

  constructor(analytics: AngularFireAnalytics) {
    analytics.logEvent('starting the app');
  }
}
